import { Box, Divider, Typography } from "@mui/material";
import { Link, palette } from "@powerdiary/components-library/lib";

import styles from "./MobileFooter.module.css";

interface MobileFooterProps {
    enableZandaFooter: boolean;
}

export default function MobileFooter({ enableZandaFooter }: MobileFooterProps) {
    return (
        <Box className={styles.container} data-test-id="section_mobile_footer">
            {enableZandaFooter && (
                <Box className={styles.logoContainer}>
                    <img src="/images/logo/zanda-neutral.svg" alt="Zanda" data-test-id="image_footer_mobile_zanda" />
                    <Typography variant="paragraphSmallBold" color={palette.neutral["500"]}>
                        zanda
                    </Typography>
                </Box>
            )}

            <Box className={styles.linksContainer}>
                {enableZandaFooter && (
                    <>
                        <Link
                            variant="paragraphExtraSmallRegular"
                            color={palette.neutral["500"]}
                            target="_blank"
                            rel="noopener"
                            href="https://zandahealth.com/"
                            data-test-id="link_heart_smart_health"
                        >
                            The heart of smart health practices
                        </Link>
                        <Divider orientation="vertical" sx={{ height: "16px" }} />
                    </>
                )}
                <Link
                    variant="paragraphExtraSmallRegular"
                    href="https://www.zandahealth.com/privacy-policy/"
                    target="_blank"
                    rel="noopener"
                    color={palette.neutral["500"]}
                    data-test-id="link_privacy_mobile"
                >
                    Privacy
                </Link>
                <Divider orientation="vertical" sx={{ height: "16px" }} />
                <Link
                    variant="paragraphExtraSmallRegular"
                    href="https://www.zandahealth.com/terms-of-use/"
                    target="_blank"
                    rel="noopener"
                    color={palette.neutral["500"]}
                    data-test-id="link_terms_mobile"
                >
                    Terms of Use
                </Link>
            </Box>
        </Box>
    );
}
